// 用来存储数据
const state = {
  routerIndex:1,
}
// 响应组件中的事件
const actions = {
  GetRouterIndex({ commit, state },index){
    console.log(index,'actions--index--')

    commit('GET_ROUTER_INDEX', index)
  }
}
// 操作数据
const mutations = {
  GET_ROUTER_INDEX:(state, index) => {
    console.log(index,'mutations--index--')
    state.routerIndex = index
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/menu.js